import type { EshopsData } from '@twisto/api-cms'

import type { EshopSelection } from '../../molecules/eshops-navigation/types'

export const getSelectedEshops = (
  selection: EshopSelection,
  data?: EshopsData
) => {
  if (selection.type === 'pay-in-3') {
    return data?.pay_in_three_eshops || []
  }

  if (selection.type === 'category') {
    return (data?.eshops || []).filter(
      (eshop) =>
        Array.isArray(eshop.categories) &&
        eshop.categories.includes(selection.category.slug)
    )
  }

  return []
}
